/**
 * Determines whether a filter section should be rendered.
 *
 * Rules:
 * - Button filters require more than one option (a single-option button group is useless).
 * - All other filter types require at least one option.
 * - A filter marked active is always shown regardless of facet data.
 */
export function isFilterVisible(filter, facet) {
    if (filter.active)
        return true;
    if (!facet)
        return false;
    const count = Object.keys(facet.facet_data || {}).length;
    return filter.type === "button" ? count > 1 : count > 0;
}
